import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterLandingReport from 'views/reports/landingReport2/filterLandingReport'; // Importing filter component for landing report
import TableLandingReport from 'views/reports/landingReport2/tableLandingReport'; // Importing table component for landing report
import DetailsLandingReport from 'views/reports/landingReport2/detailsLandingReport'; // Importing details component for landing report
import RecordLandingReport from 'views/reports/landingReport2/recordLandingReport'; // Importing record component for landing report

/**
 * LandingReport2View class extends JetView to create a landing report view.
 */
export default class LandingReport2View extends JetView {
    /**
     * Configures the layout of the landing report view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const right = {
            // Right section configuration
            type: 'wide',
            rows: [PlayersView, RecordLandingReport, DetailsLandingReport],
        };
        const right2 = {
            // Alternative right section configuration
            height: 1,
            id: 'right2',
            width: screen.width - 54,
            type: 'wide',
            rows: [RecordLandingReport, DetailsLandingReport],
        };
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('treetable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('treetable').refresh(); // Refresh the table
                            $$('treetable').scrollTo(100, 0); // Scroll to the top
                        },
                    },
                },
                {
                    view: 'pager', // Pager configuration
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: 10,
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export dropdown
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            if (value == 1) {
                                // Excel export
                                var table = $$('treetable'); // Reference to the table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export event
                                    {
                                        NameReport:
                                            ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) + _('Landing'),
                                        TypeReport: 'Excel',
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Landing'),
                                    ignore: { detailTittle: true },
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                                _('Landing'),
                                            TypeReport: 'PDF',
                                        },
                                    ]);
                                    webix.toPDF($$('treetable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Landing'),
                                        autowidth: true,
                                        ignore: { detailTittle: true },
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export dropdown value
                        }.bind(this),
                    },
                },
            ],
        };
        const left = {
            // Left section configuration
            css: 'int-left',
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme,
                    elements: [
                        { view: 'label', label: _('Reporte de Landing') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search', // Search button
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        // Click event to show filter popup
                                        $$('filterPopup').show();
                                    },
                                },
                            ],
                        },
                    ],
                },
                FilterLandingReport, // Filter component
                TableLandingReport, // Table component
                toolbar, // Toolbar component
            ],
        };
        const avanc = {
            // Advanced details accordion configuration
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [
                { id: 'dColl', header: _('Detalles Avanzados'), body: right }, // Accordion body
            ],
        };
        const avancResp = {
            // Responsive advanced details accordion configuration
            view: 'accordion',
            multi: true,
            collapsed: true,
            rows: [
                {
                    id: 'dColl',
                    header: _('Detalles Avanzados'),
                    body: right,
                    minWidth: 250,
                    on: {
                        onItemClick: function () {
                            // Event handler for item click
                            var height;
                            $$(function () {
                                height =
                                    $$('.scrolling > .webix_scroll_cont').height() -
                                    $$('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                if (!$$('dColl').config.collapsed) {
                                    $$('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                } else {
                                    height =
                                        $$('.scrolling > .webix_scroll_cont').height() -
                                        $$('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                    $$('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            // Return the main layout configuration
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Include left section
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Execute when Webix is ready
            if (screen.width < 500 || screen.height < 500) {
                $$('toolbar').hide(); // Hide toolbar on small screens
            }
            if (screen.width > 500 && screen.height > 500) {
                $$('button-search').hide(); // Hide search button on larger screens
            }
            $.fn.scrollBottom = function () {
                // jQuery function to get scroll bottom position
                return $$(document).height() - this.scrollTop() - this.height();
            };
        });
    }
}

// FILE DOCUMENTED
